module.exports = __webpack_public_path__ + "r-v3/img/notice.274cb97e.svg";